import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HomeService } from './../../services/home/home.service';
import { YodleeQuery } from '@1bill-app/services/yodlee/yodlee.query';
import { YodleeService } from '@1bill-app/services/yodlee/yodlee.service';
import {
  AccountHistoryItem,
  YodleeAccount,
  YodleeAccountGroup,
} from '@1bill-app/services/yodlee/yodlee.types';
import { first } from 'lodash';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { ROUTE_HOMEPAGE } from '@1bill-app/constants';
import { getLastOfInterval } from '@1bill-app/helpers/date.helpers';
import dayjs from 'dayjs';

@Component({
  selector: 'app-cash-screen',
  templateUrl: './cash-screen.page.html',
  styleUrls: ['./cash-screen.page.scss'],
})
export class CashScreenPage implements OnInit {
  constructor(
    private homeService: HomeService,
    private yodleeQuery: YodleeQuery,
    private logger: NGXLogger,
    private yodleeService: YodleeService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  public homeDataEvent$ = this.homeService.homeDataEvent$;
  subs = new SubSink();
  type: string;
  title: string = 'Cash';
  defaultHref = ROUTE_HOMEPAGE;
  // accountsHistory: AccountHistoryItem[] = [];
  accountGroup: YodleeAccountGroup;
  accounts: YodleeAccount[];
  date = dayjs().format('YYYY-MM-DD');
  interval: 'M' | 'W' | 'Y' = 'M';
  availablePeriods: string[];

  cashChartData$ = this.yodleeQuery.cashScreenChartData$;
  currentDurationDate$ = this.yodleeQuery.cashScreenCurrentDurationDate$;

  public accounts$: Observable<YodleeAccount[]> = this.route.queryParams.pipe(
    mergeMap((param) =>
      this.yodleeQuery.accounts$.pipe(
        map((accounts) => {
          const type = param['type'];
          if (!type) {
            this.router.navigateByUrl(ROUTE_HOMEPAGE);
            return;
          }
          this.type = type;
          this.title = this.type.charAt(0).toUpperCase() + this.type.slice(1);
          this.accounts = accounts?.filter((account) => account.type === type);
          if (!this.accounts?.length) {
            this.router.navigateByUrl(ROUTE_HOMEPAGE);
            return;
          }
          return this.accounts;
        }),
        tap((accounts) => {
          const account = first(accounts);
          this.groupTitle = account?.displayGroupType;
        }),
      ),
    ),
  );
  loading$ = this.yodleeQuery.isLoading$;
  public groupTitle: string = 'Accounts';

  async ngOnInit() {
    this.subs.sink = this.yodleeService.getAccounts().subscribe();
    // this.subs.sink = this.yodleeService
    //   .getMultipleAccountHistoricalBalances()
    //   .subscribe((result) => {
    //     this.accountsHistory = result;
    //     this.logger.log('Accounts history:', this.accountsHistory);
    //   });
    this.subs.sink = this.fetchChartData().subscribe((chartData) => {
      this.logger.log('Updated chart data:', chartData);

      // Update chart appearance
    });
    this.subs.sink = this.yodleeQuery.cashScreenChartData$.subscribe((result) => {
      if (result) {
        this.availablePeriods = result.chartData
          .filter((cd) => !!cd)
          .map((cd) => cd.date)
          .sort((a, b) => (a > b ? -1 : 1));
      }
    });

    this.subs.sink = this.yodleeQuery.accountListUpdated$.subscribe((hasUpdated: string) => {
      this.type = this.route.snapshot.queryParamMap.get('type');
      this.fetchChartData().subscribe();
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.refreshData();
      }
    });
  }

  async refreshData() {
    this.subs.sink = this.yodleeService.getAccounts().subscribe();
    this.subs.sink = this.fetchChartData().subscribe((chartData) => {
      this.logger.log('Updated chart data:', chartData);
    });
    this.subs.sink = this.yodleeQuery.cashScreenChartData$.subscribe((result) => {
      if (result) {
        this.availablePeriods = result.chartData
          .filter((cd) => !!cd)
          .map((cd) => cd.date)
          .sort((a, b) => (a > b ? -1 : 1));
      }
    });
    this.subs.sink = this.yodleeQuery.accountListUpdated$.subscribe((hasUpdated: string) => {
      this.type = this.route.snapshot.queryParamMap.get('type');
      this.fetchChartData().subscribe();
    });
  }

  fetchChartData(overrideType?: string) {
    return this.yodleeService.getCashScreenWealthData(
      this.date,
      this.interval,
      overrideType ?? this.type ?? this.route.snapshot.queryParamMap.get('type'),
    );
  }

  handleLinkBankAccount() {
    this.homeService.presentLinkBankAccountModal();
  }

  getTitle() {
    return this.title;
  }

  intervalChanged(to: 'M' | 'W' | 'Y') {
    this.interval = to;
    this.date = getLastOfInterval(this.interval);
    this.fetchChartData().subscribe();
  }

  durationChanged(to: string) {
    this.date = to;
    this.fetchChartData().subscribe();
  }

  // getCurrentBalTotal() {
  //   let total = 0;
  //   this.logger.log('acc', this.accounts.length);
  //   for (let i = 0; i < this.accountsHistory.length; i++) {
  //     if (this.accounts.find(acc => acc.id == this.accountsHistory[i].id)) {
  //       total +=
  //         this.accountsHistory[i].historicalBalances[
  //           this.accountsHistory[i].historicalBalances.length - 1
  //         ].balance.amount;
  //     }

  //     // total += this.accountsHistory[].history[0].balance.amount;
  //   }
  //   return total;
  // }

  doRefresh(event) {
    // this.isPullToRefresh = true;
    this.yodleeService
      .getAccounts()
      .toPromise()
      .then(() => {
        // this.isPullToRefresh = false;
        event.target.complete();
      })
      .catch((err) => {
        this.logger.log(err);
        event.target.complete();
        // this.isPullToRefresh = false;
      });
  }
}
